export const getEnv = {
  amb: process.env.REACT_APP_AMBIENCE,
}

export const getAmbAddr = () => {
  return process.env.REACT_APP_AMBIENCE == 'prod' ? 'admissao/' : ''
}
